export const styles = () => ({
  inputPadding: {
    paddingLeft: 10,
  },
  listItem: {
    "&:hover": {
      backgroundColor: "#e6e6e6",
    },
    backgroundColor: "white",
  },
  nonEditingDate: {
    border: "1px solid lightblue",
  },
});



// WEBPACK FOOTER //
// ./src/pages/director/seasons/components/season-list-item/styles.ts